import { type ReactNode } from 'react';

import { Text } from '@/components/typography';

type StatFieldProps = {
  label: ReactNode;
  children: ReactNode;
};

const StatField = ({ label, children }: StatFieldProps) => {
  return (
    <div className="flex flex-col items-start">
      <Text variant="footnote">{label}</Text>
      {children}
    </div>
  );
};

export default StatField;
